import { SettingConst } from '@faire/web-api--source/types';

/**
 * Sample rate BPS for showing the Qualtrics CSAT survey to retailers
 */
export const QUALTRICS_RETAILER_SURVEY_INTERCEPT_SAMPLE_RATE_BPS =
  'QUALTRICS_RETAILER_SURVEY_INTERCEPT_SAMPLE_RATE_BPS' as SettingConst<
    'QUALTRICS_RETAILER_SURVEY_INTERCEPT_SAMPLE_RATE_BPS',
    number,
    'RETAILER' | 'VISITOR_WEB'
  >;
